require('./baseState.js');

Pegasus.InfoGatheringState = Pegasus.BaseState.extend({
  gotoIdle: Em.K,
  headerCopy: {},
  next: '',

  setup: function(){
    var headerData = Pegasus.lookupController('header').get('content');

    this.set( 'next', Pegasus.get('externalProxy.mostRecentPath') );
    this.set( 'headerCopy', $.extend({}, headerData) );
  },

  exitModal: function(){
    Pegasus.lookupController('header').set('content', this.get('headerCopy'));

    Pegasus.stateMachine.closeModal();
    Pegasus.set('status', 'editing');
    Pegasus.stateMachine.transitionTo('idling');
  },

  saveExitModal: function(){
    var path = this.get('next');
    
    Pegasus.stateMachine.closeModal();

    if (path === 'confirm') {
      Pegasus.stateMachine.transitionTo('validating.confirming');
    } else if (path === 'testEmail') {
      Pegasus.get('externalProxy').send('sendTestEmailFromValidationModal');
    } else {
      Pegasus.set('status', 'editing');
      Pegasus.stateMachine.transitionTo('idling');
    }
  }
});
